import { useSelector } from 'react-redux';
import { RootState } from '../store';

export const useAuth = () => {
  const { user, isAuthenticated, loading, token, timesheetReports } = useSelector((state: RootState) => state.auth);

  const hasRole = (role: string): boolean => {
    return user?.role === role;
  };

  const hasAnyRole = (roles: string[]): boolean => {
    return user && user.role ? roles.includes(user.role) : false;
  };

  const canViewUserData = (userId?: string): boolean => {
    if (!user) return false;
    
    if (user.role === 'admin' || user.role === 'vp_sales' || user.role === 'finance') {
      return true;
    }
    
    if (user.role === 'sales_manager') {
      return true;
    }
    
    return user.id === userId;
  };

  return {
    user,
    isAuthenticated,
    loading,
    token,
    timesheetReports,
    hasRole,
    hasAnyRole,
    canViewUserData,
  };
};